import { Controller } from "stimulus"
import * as mdk from "../services/mdk";
export default class extends Controller {
    static targets=['cardNumber','expireYy','expireMm','cardholderName','securityCode','form','notification','cardErrorMessage']

    connect() {
        if(document.getElementById('err_notification') != null){
            const button = this.notificationTarget.children.namedItem('notification_close')
            button.addEventListener('click',() => {
                this.notificationTarget.style = 'display: none'
            })
        }
    }

    register(onSuccessCallback,onErrorCallback=null) {
        const formElem = this.formTarget
        const notificationElem = this.notificationTarget
        const skipFlag = formElem.elements.namedItem('card_skip_flag');
        const onSuccess = (token) => {
            const tokenElem = formElem.elements.namedItem('mdk_token')
            tokenElem.value = token
            const skipFlag = formElem.elements.namedItem('card_skip_flag');
            skipFlag.value = null;
            const btn = formElem.elements.namedItem('token_submit')
            if(btn != null){
              btn.click();
            }

            if(typeof onSuccessCallback == "function"){
                onSuccessCallback()
            }
        }
        const onError = (message) => {
            const messageElem = notificationElem.children.namedItem('notification_message')
            notificationElem.style = 'display:block'
            messageElem.innerText = this.cardErrorMessageTarget.innerText;
            if(typeof onErrorCallback == "function"){
                onErrorCallback()
            }
            if(message != null){
                throw new Error(message)
            }
        }
        let locale;
        if(document.documentElement.lang == 'ja'){
            locale = 'ja'
        }else{
            locale = 'en'
        }
        mdk.get_token(
            this.cardNumberTarget.value,
            this.expireMmTarget.value + '/' + this.expireYyTarget.value,
            this.cardholderNameTarget.value,
            this.securityCodeTarget.value,
            onSuccess,
            onError,
            locale
        )
    }

    sliceMaxLength(event){
        const el = event.currentTarget;
        const params = event.params;
        el.value = el.value.slice(0, params.max);
    }
    zeroFill(event){
        const el = event.currentTarget;
        el.value = ('0'+el.value).slice(-2);
    }
    numberRange(event){
        const el = event.currentTarget;
        const min = parseInt(el.getAttribute("min"));
        const max = parseInt(el.getAttribute("max"));
        if(parseInt(el.value) > max){ el.value = max; }
        if(parseInt(el.value) < min){ el.value = min; }
    }
}
